<template>
  <b-modal
    :active.sync="showModal"
    :width="450"
  >
    <form
      class="form"
      @submit.prevent="submit"
    >
      <div
        class="modal-card"
        style="width: auto"
      >
        <header class="modal-card-head is-block">
          <span class="icon-static xl large-user" />
          <h4 class="title is-4">
            Reset your password
          </h4>
        </header>
        <section
          v-if="!complete"
          class="modal-card-body"
        >
          <div
            v-for="(err, i) in formErrors.non_field_errors"
            :key="i"
            class="message is-danger has-text-left"
          >
            <div class="message-body">
              {{ err }}
            </div>
          </div>
          <div class="field">
            <label class="label">Email address</label>
            <div class="control">
              <input
                id="id_email"
                v-model="email"
                type="email"
                name="email"
                autofocus
                class="input"
                required
                placeholder="Email address"
              >
            </div>
          </div>
        </section>
        <section
          v-else
          class="modal-card-body"
        >
          <p>We've emailed you instructions for setting your password. You should receive them shortly.</p>
          <p>If you don't receive an email, please make sure you've entered the address you registered with, and check your spam folder.</p>
        </section>
        <footer
          v-if="!complete"
          class="modal-card-foot is-block"
        >
          <button
            type="submit"
            class="button is-fullwidth is-primary margin-bottom is-large"
          >
            Reset
          </button>
        </footer>
      </div>
    </form>
  </b-modal>
</template>

<script>
export default {
  name: 'ThePasswordResetModal',

  data () {
    return {
      complete: false,
      email: '',
      password: '',
      formErrors: {}
    }
  },

  computed: {
    showModal: {
      get: function () {
        return this.$store.getters['auth/showPasswordResetModal']
      },
      set: function (newValue) {
        if (newValue === true) {
          this.$store.dispatch('auth/showPasswordResetModal')
        } else {
          this.$store.dispatch('auth/hidePasswordResetModal')
        }
      }
    }
  },

  methods: {
    submit () {
      const email = this.email

      this.resetForm()

      this.$store.dispatch('auth/passwordResetRequest', email)
        .then(() => {
          this.complete = true
        })
        .catch((error) => {
          if (error.response.status === 400) {
            this.$set(this, 'formErrors', error.response.data)
            return
          }
          return Promise.reject(error.response)
        })
    },

    resetForm () {
      this.formErrors = {}
      this.email = ''
    }
  }
}
</script>

<style>

</style>
